<template lang="pug">
.doDIALOGUE(:style="dialogueList[contState].name === '领导讲话内容' || dialogueList[contState].name === '领导' ? '' : 'flex-direction: row-reverse;'")
  img(
      src="../../../../assets/doCase/head/ld.png",
      v-if="dialogueList[contState].name === '领导讲话内容' || dialogueList[contState].name === '领导'"
    )
  img(src="../../../../assets/doCase/head/xz.png", v-else)
  .content(:class="dialogueList[contState].name === '领导讲话内容' || dialogueList[contState].name === '领导'?'left-bubbl':'right-bubbl'")
    .title  {{dialogueList[contState].name==='领导讲话内容'?"领导":"小张"}}
    img(src='../../../../assets/doCase/yinhao.png').img.left-img
    .LEADERSHIPOFFICE-content  {{dialogueList[contState].content}}
    button.next(@click='next',:class="{'Disabling':AssessmentState}")  下一步
    img(src='../../../../assets/doCase/yinhao.png').img.right-img
</template>
<script>
export default {
  props: ["cont"],
  data() {
    return {
      AssessmentState: false,
      contState: 0,
      dialogueList: JSON.parse(this.cont.metas)
    };
  },
  created() {
    console.log(this.cont);
  },
  methods: {
    next() {
      /** 点击下一步按钮 */
      if (!this.AssessmentState) {
        if (this.dialogueList.length === this.contState + 1) {
          this.$emit("next");
          this.AssessmentState = true;
        }
        this.contState += 1;
      }
    }
  }
};
</script>
<style lang="stylus" scoped>
.doDIALOGUE
  left 0
  margin 0 32px
  position fixed
  height 156px
  bottom 32px
  width calc(100% - 64px)
  text-align left
  overflow hidden
  display flex
  .content
    position relative
    margin 0 32px
    height 156px
    background linear-gradient(180deg, #EAEBE4 0%, #FFFFFF 100%)
    box-shadow 0px -2px 4px 0px rgba(0, 0, 0, 0.1)
    opacity 0.94
    text-align left
    width 100%
    border-radius 8px
    .title
      font-size 24px
      font-family MicrosoftYaHeiUI
      color rgba(42, 46, 54, 0.8)
      line-height 28px
      margin 22px 156px
    .img
      width 40px
      transform rotate(180deg)
    .left-img
      margin-left 110px
      float left
    .right-img
      float right
      margin-right 150px
    .next
      width 100px
      height 40px
      background rgba(58, 118, 210, 1)
      border-radius 4px
      border none
      outline none
      font-size 14px
      font-family MicrosoftYaHeiUI
      color rgba(255, 255, 255, 1)
      line-height 18px
      float right
      margin-right 163px
    .next1
      margin-right 16px
    .LEADERSHIPOFFICE-content
      font-size 16px
      font-family MicrosoftYaHeiUI
      color rgba(42, 46, 54, 0.75)
      line-height 28px
      float left
      margin-left 5px
      width 55%
    .Disabling
      background #dddddd
.right-bubbl:after
  content ''
  position absolute
  left 100%
  top 32px
  width 24px
  height 24px
  border-width 0
  border-style solid
  border-color transparent
  border-bottom-width 18px
  border-bottom-color currentColor
  border-radius 0 0 32px 0
  color #FFFFFF
  opacity: 0.94;
.left-bubbl:after
  content:'';
  position:absolute;
  right:100%;
  top:32px;
  width:24px;
  height:24px;
  border-width:0;
  border-style:solid;
  border-color:transparent;
  border-bottom-width:18px;
  border-bottom-color:currentColor;
  border-radius:0 0 0 32px;
  color:#FFFFFF;
  opacity: 0.94;
</style>
